import PlayerTasks from '@/components/features/players/tasks'

interface Props {
    mongo_player_id: string;
}

const Reports = ({ mongo_player_id }: Props) => {
  return (<PlayerTasks mongo_player_id={mongo_player_id} completed={true}/>)
}

export default Reports